var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide"}},[(_vm.hasContentSlot && _vm.visible)?_c('div',{staticClass:"sticky-bar",class:("sticky-bar--" + _vm.position),attrs:{"data-cy":"sticky-bar"}},[_vm._t("content")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }